/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StringListResult } from '../../models/string-list-result';

export interface ApiTeamTeamsStatheadGet$Plain$Params {
}

export function apiTeamTeamsStatheadGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTeamTeamsStatheadGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StringListResult>> {
  const rb = new RequestBuilder(rootUrl, apiTeamTeamsStatheadGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StringListResult>;
    })
  );
}

apiTeamTeamsStatheadGet$Plain.PATH = '/api/team/teams/stathead';
